<template>
  <d-navbar-nav class="border-left flex-row">
    <li class="nav-item border-right dropdown notifications">
      <a class="nav-link nav-link-icon text-center" v-d-toggle.notifications>
        <div class="nav-link-icon__wrapper">
          <i class="material-icons">&#xE7F4;</i>
          <d-badge pill theme="danger">{{ countUnread }}</d-badge>
        </div>
      </a>
    </li>
    <li class="nav-item dropdown">
      <a
        class="nav-link dropdown-toggle text-nowrap px-3 text-white"
        v-d-toggle.user-actions
      >
        <img
          class="user-avatar rounded-circle mr-2"
          :src="user.settings.image.url_image"
          v-if="user.settings.image.name"
          :alt="user.name"
        />
        <img
          class="user-avatar rounded-circle mr-2"
          src="@/assets/images/avatars/enhanced-buzz.jpeg"
          :alt="user.name"
          v-else
        />
        <span class="d-none d-md-inline-block">{{ user.name }}</span>
      </a>
      <d-collapse
        id="user-actions"
        ref="userActions"
        class="dropdown-menu dropdown-menu-small"
      >
        <router-link
          class="dropdown-item"
          :to="{ name: 'admin-perfil' }"
          @click.native="closeUserActions()"
        >
          <i class="material-icons">&#xE7FD;</i>
          Perfil
        </router-link>
        <router-link
          class="dropdown-item"
          :to="{ name: 'admin-settings' }"
          @click.native="closeUserActions()"
          v-if="isAdmin || hasSettingsOrAccessControlModule"
        >
          <i class="material-icons">settings</i>
          Configuração
        </router-link>
        <d-dropdown-divider />
        <a class="nav-link text-danger dropdown-item">
          <div @click.prevent="logout()">
            <i class="material-icons text-danger">&#xE879;</i>
            Sair
          </div>
        </a>
      </d-collapse>
    </li>
  </d-navbar-nav>
</template>

<script>
import { MODEL } from '_modules/user/components/UserModel';
import { mapActions } from 'vuex';

export default {
  name: 'navbar-nav',
  computed: {
    isAdmin() {
      const { isAdmin } = this.$store.state.user;
      return isAdmin;
    },
    user() {
      const { user } = this.$store.state.user;
      if (user) {
        return user;
      }
      return { ...MODEL };
    },
    hasSettingsOrAccessControlModule() {
      const { user } = this.$store.state.user;
      if (user.modules.some(item => item.slug === 'settings' || item.slug === 'access-control')) {
        return true;
      }
      return false;
    }
  },
  data() {
    return {
      countUnread: null,
    };
  },
  methods: {
    ...mapActions({
      activeAlert: 'activeAlert',
      storeLogout: 'logout',
      checkAdmin: 'checkAdmin',
    }),
    logout() {
      this.storeLogout().then(() => {
        this.$router.push('/login');
      });
    },
    closeUserActions() {
      this.$refs.userActions.show = false;
    },
    close(e) {
      if (!this.$el.contains(e.target)) {
        this.closeUserActions();
      }
    },
  },
  mounted() {
    document.addEventListener('click', this.close);
    this.checkAdmin();
  },
  beforeDestroy() {
    document.removeEventListener('click', this.close);
  }
};
</script>

<style>
.nav-link:hover {
  cursor: pointer;
}
.dropdown-menu {
  left: auto;
}
</style>
